import type * as React from 'react';

import { cn } from './lib/cn';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = ({ className, ref, ...props }: TextareaProps & { ref?: React.Ref<HTMLTextAreaElement> }) => (
  <textarea
    className={cn(
      'box-border flex min-h-[80px] w-full overflow-y-auto rounded-2xl border border-role-outline-subtle not-placeholder-shown:border-role-info-outline bg-role-background px-3 py-2 text-[14px] text-role-on-background placeholder-role-outline-subtle shadow-none outline-hidden transition-all [-ms-overflow-style:none] [scrollbar-width:none] file:border-0 file:bg-transparent file:font-medium file:text-[14px] hover:border-role-outline-subtle hover:bg-[#f5f5f5] focus-visible:border-role-outline-subtle focus-visible:bg-role-background focus-visible:shadow-none focus-visible:ring-2 focus-visible:ring-role-info-outline focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:border-role-disabled disabled:bg-role-disabled disabled:text-role-on-disabled [&::-webkit-scrollbar]:hidden',
      className,
    )}
    ref={ref}
    {...props}
  />
);
Textarea.displayName = 'Textarea';

export { Textarea };
